<template>
  <div class="handle-open">
    <div class="close-open" @click="closeWindow"><i class="el-icon-close"></i></div>
    <div class="title-top-alarm">
      <div><span>事件处理</span></div>
      <div class="line-title"></div>
    </div>
    <div style="margin: 10px 70px;font-size: 16px;color: #808080">
      <el-row style="margin-top: 15px">
        <el-col :span="12" class="h-line">事件时间：<span class="span-color">{{time}}</span></el-col>
        <el-col :span="12" class="h-line">
          事件类型：
          <img style="vertical-align: sub;width: 20px;height: 20px" :src="getTypeImgAlarm(alarmtype)">
          <span class="span-color">{{getAType()}}</span>
        </el-col>
      </el-row>
      <el-row v-if="alarmtype !== 'phonein'">
        <el-col :span="12" class="h-line">设备编号：<span class="span-color">{{deviceid}}</span></el-col>
        <el-col :span="12" class="h-line">设备类型：
          <span class="span-color" v-if="handleAlarmRow.row.device">{{getDeviceType(devicetype)}}</span>&nbsp;&nbsp;
          <img v-if="handleAlarmRow.row.device && (handleAlarmRow.row.device.devicetype === 300 || handleAlarmRow.row.device.devicetype === 350) && handleAlarmRow.row.lng !== 0 && handleAlarmRow.row.lat !== 0"
               style="vertical-align: sub;width: 20px;height: 20px;cursor: pointer"
               src="/static/tableIcon/icon_location.png"
               @click="openMapLocation">
<!--          <img v-if="handleAlarmRow.row.device && handleAlarmRow.row.device.devicetype === 700 && homeObj.home.lng !== 0 && homeObj.home.lat !== 0"-->
<!--               style="vertical-align: sub;width: 20px;height: 20px;cursor: pointer"-->
<!--               src="/static/tableIcon/icon_location.png"-->
<!--               @click="openMapLocation">-->
        </el-col>
      </el-row>
      <el-row v-if="alarmtype !== 'phonein' && handleAlarmRow.row.device && (handleAlarmRow.row.device.devicetype === 700 || handleAlarmRow.row.device.devicetype === 504)">
        <el-col :span="24" class="h-line">安装位置：<span>{{h_install_location}}</span>
        </el-col>
      </el-row>
      <div v-if="handleAlarmRow.row.device && (handleAlarmRow.row.device.devicetype === 300 || handleAlarmRow.row.device.devicetype === 350)">
        <el-row>
          <el-col :span="12" class="h-line">服务对象：<span class="span-color">{{p_name}}</span></el-col>
          <el-col :span="12" class="h-line">性别：<span class="span-color">{{p_sex}}</span></el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="h-line">出生日期：<span class="span-color">{{p_birthday}}</span></el-col>
        </el-row>
      </div>
      <el-row>
        <el-col :span="24" class="all-three-point h-line" :title="h_address">楼栋/楼层/房间：<span class="span-color">{{h_address}}</span></el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <span>处理内容：</span>
          <el-select v-fixZoom v-model="headle" filterable placeholder="请选择" style="width: 260px" @change="changeHandle">
            <el-option v-for="item in headleOptions" :key="item.index" :label="item" :value="item"></el-option>
          </el-select>
        </el-col>
        <el-col :span="12" v-if="headle === '其他'">
          <span>其他内容：</span>
          <el-input style="width: 260px" placeholder="请输入其他处理内容" v-model="handleMessage"></el-input>
        </el-col>
      </el-row>
      <el-row style="height: 46px;margin-top: 20px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeWindow()"><span>取消</span></div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn-green" @click="handleCommit()"><span>现在处理</span></div>
        </el-col>
      </el-row>
    </div>
    <el-dialog width="650px" :visible.sync="showLocation" v-if="showLocation" :close-on-click-modal="false" append-to-body class="all-open">
      <div class="title-top-alarm">
        <div><span>位置详情</span></div>
        <div class="line-title"></div>
      </div>
      <div style="height: 450px">
        <track-details :trackDetailsObj="handleMapObj"></track-details>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {sendSub} from '../../../mq'
import trackDetails from '../../datamanagement/deviceComponents/trackDetails'
import {hanlealarm} from '../../../api/handlealarm'
import {queryelderlybyid} from '../../../api/yanglaoyuan'
export default {
  name: 'openHandleAlarm',
  components: {trackDetails},
  props: {
    handleAlarmRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      headle: '',
      headleOptions: ['已处理', '误报', '其他'],
      handleMessage: '',
      imgIconAlarm: [],
      // 固定信息开始
      alarmid: '',
      time: '',
      alarmtype: '',
      p_name: '',
      p_birthday: '',
      p_sex: '',
      deviceid: '',
      devicetype: '',
      h_install_location: '',
      h_address: '',
      prehandle: 0,
      // 结束
      showLocation: false,
      handleMapObj: {
        type: 'alarm',
        alarmRow: '',
        person: '',
        device: ''
      }
    }
  },
  created () {
    this.imgIconAlarm = this.getImgArr.getImgIconAlarm()
    this.alarmid = this.handleAlarmRow.row.id
    this.handleMapObj.alarmRow = this.clone(this.handleAlarmRow.row)
    this.handleMapObj.device = this.clone(this.handleAlarmRow.row.device)
    if (this.handleAlarmRow.row.device && this.handleAlarmRow.row.device.pid !== 0) {
      this.getElderlyData(this.handleAlarmRow.row.device.pid)
    }
    console.log(this.handleAlarmRow.row)

    this.time = this.handleAlarmRow.row.time
    this.alarmtype = this.handleAlarmRow.row.alarmtype
    // p_birthday p_sex
    this.deviceid = this.handleAlarmRow.row.device ? this.handleAlarmRow.row.device.deviceid : ''
    this.devicetype = this.handleAlarmRow.row.device ? this.handleAlarmRow.row.device.devicetype : ''
    this.h_install_location = this.handleAlarmRow.row.device ? this.handleAlarmRow.row.device.h_installlocation : ''
    this.h_address = this.handleAlarmRow.row.device ? (this.handleAlarmRow.row.device.build_name + ' / ' + this.handleAlarmRow.row.device.floor_name + ' / ' + this.handleAlarmRow.row.device.home_room) : ''
    this.prehandle = this.handleAlarmRow.row.prehandle
    /* 养老院处理弹窗 */
  },
  methods: {
    // 老人信息
    getElderlyData (id) {
      let data = {
        ep_id: id
      }
      queryelderlybyid(data).then(res => {
        let elderly = res.data.elderly
        this.p_name = elderly.elderly_name
        this.p_birthday = elderly.birth_date
        this.p_sex = this.getGender(elderly.gender)
        let p = {
          name: elderly.elderly_name,
          photourl: elderly.elderly_photo,
          phone: elderly.contact_phone_number
        }
        this.handleMapObj.person = p
      })
    },
    // 获取性别
    getGender (gender) {
      if (gender === '0') {
        return '未知性别'
      } else if (gender === '1') {
        return '男性'
      } else if (gender === '2') {
        return '女性'
      } else if (gender === '9') {
        return '未说明性别'
      } else {
        return gender
      }
    },
    changeHandle (val) {
      if (val === '其他') {
        this.handleMessage = ''
      } else {
        this.handleMessage = val
      }
    },
    getTypeImgAlarm (type) {
      let num = this.commonType.getAlarmTypeIcon(type)
      return this.imgIconAlarm[num].imgUrl
    },
    getAType () {
      return this.commonType.getAlarmType(this.alarmtype)
    },
    getDeviceType (type) {
      if (type === 700) {
        return '智能网关'
      }
      return this.commonType.getDeviceType(type)
    },
    openMapLocation () {
      this.showLocation = true
    },
    closeWindow () {
      let mqtts = this.$store.state.user.mqtts
      let name = this.$store.state.user.personname
      let jobnum = this.$store.state.user.syspersonjobnum
      let dohandle = {id: this.alarmid, name: name, jobnum: jobnum}
      sendSub('/handledone' + mqtts[0], JSON.stringify(dohandle))
      this.store2.dispatch('other/update_del_alarm', this.alarmid).then(() => {
        if (this.$route.path === '/handleAlarm') {
          this.golobleObject.updateTableAlarm()
        }
      })
      let obj = {type: 'close'}
      this.$emit('getFatherHandle', obj)
    },
    // 派单
    getStidImg (id) {
      this.soid = ''
      for (let i = 0; i < this.newTypes.length; i++) {
        if (id === this.newTypes[i].id) {
          if (this.newTypes[i].obj) {
            this.soid = this.newTypes[i].obj.id
          }
        }
      }
    },
    handleCommit () {
      let data = {
        aid: this.alarmid,
        so_id: 0,
        st_id: 0,
        content: this.handleMessage,
        pid: this.handleAlarmRow.row.p_pid,
        hid: this.handleAlarmRow.row.h_hid,
        orgid: this.handleAlarmRow.row.device ? this.handleAlarmRow.row.device.oid : 0,
        bid: 0
      }
      hanlealarm(data).then(res => {
        this.$notify({
          title: '成功',
          message: '成功处理该警报',
          type: 'success',
          duration: 2000
        })
        let mqtts = this.$store.state.user.mqtts
        let name = this.$store.state.user.personname
        let dohandle = {id: this.alarmid, name: name}
        sendSub('/handledone' + mqtts[0], JSON.stringify(dohandle))
        this.store2.dispatch('other/update_del_alarm', this.alarmid).then(() => {
          if (this.$route.path === '/handleAlarm') {
            this.golobleObject.updateTableAlarm()
          }
        })
        let obj = {type: 'send'}
        this.$emit('getFatherHandle', obj)
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.h-line{
  height: 36px;
}
.handle-open{
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border-radius: 6px;
  font-size: 14px;
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/openHandleAlarm.vue